import { GroupBase, GroupHeadingProps, components } from 'react-select';
import { LegendsDot } from '../../Legends/Legends.styles';
import { DefaultOption } from './DropdownOptions';
import { GroupCount, GroupName } from './TagsGroupHeading.styles';

export interface TagsGroupBase extends GroupBase<DefaultOption> {
  color: string;
  count: number;
}

export const TagsGroupHeading = (
  props: GroupHeadingProps<DefaultOption, boolean, TagsGroupBase>,
) => {
  return (
    <components.GroupHeading
      {...props}
      data-testid={`dropdown-group-${props.data.label}-heading`}
    >
      <LegendsDot color={props.data.color} />
      <GroupName>{props.data.label}</GroupName>
      <GroupCount>({props.data.count})</GroupCount>
    </components.GroupHeading>
  );
};
